/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bytes: NonNullable<unknown>, tool: NonNullable<unknown> }} Chat_Tool_Content_From_Earlier_ReadInputs */



/**
* | output |
* | --- |
* | "Content from an earlier read: {bytes} bytes read by {tool}" |
*
* @param {Chat_Tool_Content_From_Earlier_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_content_from_earlier_read = /** @type {((inputs: Chat_Tool_Content_From_Earlier_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Content_From_Earlier_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Inhalt aus einem früheren Lesevorgang: ${i?.bytes} Bytes, gelesen von ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Content from an earlier read: ${i?.bytes} bytes read by ${i?.tool}`)
});